import { checkToken } from "../services/checkToken";

export async function isLoggedIn() {
  const response = await checkToken();
  return response.isSuccess;
}
